require("./src/styles/global.css");

require("@fontsource/lato/400.css");
require("@fontsource/lato/700.css");
require("@fontsource/playfair-display/600.css");
require("@fontsource/playfair-display/700.css");
